// extracted by mini-css-extract-plugin
export default {"wrapper":"jD-z","addressLine":"kD-z","fullName":"lD-z"};